import { RouteItem } from '@eastcoal/router/types/route'

import { PLATFORM_TRADE_VOLUME_PAGE_UUID } from './constants/uuid'

export const platformTradeVolumeRoute: RouteItem = {
  title: '平台交易量',
  uuid: PLATFORM_TRADE_VOLUME_PAGE_UUID,
  path: '/platformTradeVolume',
  Component: () => import('./index')
}
